import React,{useState, useEffect} from "react"
import { Link,useNavigate,useParams } from "react-router-dom";
import axios from "axios";
import { $ } from "react-jquery-plugin";
import { exhibitionlist, exhibitionview, officials } from "../../apis/urls";
import moment from "moment";
import ReactHtmlParser from 'react-html-parser';
import { decode } from "html-entities";
import { Loader } from "rsuite";




const ExhibitionView = () => {


    const [loader,setLoader] = useState(true);

    useEffect(() => {
        $('body').removeClass('sidebar-collapsed sidebar-active').addClass('');
        $('html,body').animate({ scrollTop: 0 }, 'fast');

        // setTimeout(() => {
            Listing();
            // });
    }, []);
    
    let navigate = useNavigate();

    const { id } = useParams();
    
    const [result, setResult] = useState({});
    
    const Listing = () => {
        
        let token = "Bearer "+localStorage.getItem('token');
        //console.log(token)
    
        const instance = axios.create({
            baseURL: exhibitionview + id,
            timeout: 1000000,
            headers: {'authorization': token}
          });
    
          instance.get('').then(res => {
            setResult(res.data.data)  
            setLoader(false)
        });
    }


    const DeleteExibition= () => {
        let r = window.confirm("Are you sure you want to delete this Exhibition?" + id);

        if(r == true){
            let token = "Bearer "+localStorage.getItem('token');
        
        
            const instance = axios.create({

                baseURL: `${exhibitionlist}/delete/${id}`,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.delete('').then((response) =>{
                
                Listing();
                navigate("/exhibition")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            });
        }
    }



    return(
        <div>
        <aside class="right-side areas">    
            <div class="content-area dash-contentss">
                <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Exhibition - {decode(result?.name)}</h2>
                        </div>                    
                    
                </div>
                <nav aria-label="breadcrumb">
                    <ol className="breadcrumb">
                    <li className="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                        <li className="breadcrumb-item"><Link to={"/exhibition"}>Exhibitor</Link></li>
                        <li className="breadcrumb-item active" aria-current="page">Exhibitor View</li>
                    </ol>
                </nav>


                {result && !loader &&
                <div class="event-details-wrprs" style={{margin:"auto", maxWidth:'100%'}}>
                    <div class="row">
                        <div class="col-md-12">
                            <div class="row event-basic-details-wrpr">
                                <div class="col-md-6">
                                    {result?.image?
                                        <img src={result?.image} width="" height="100%" alt="" />:
                                        <div className="img-wrpr" />
                                    }
                                </div>
                                <div class="col-md-6 event-basic-details">
                                    <h2>{decode(result?.name)}</h2>
                                    {ReactHtmlParser(decode(result?.description))}

                                    {/* <div class="date-time-seats">

                                    <div class="date-time">
                                        <label>Date</label>
                                        <div class="starttime-endtime">
                                        <div class="starttime">{moment(result.start_date).format('ddd, MMM DD, YYYY')}</div>
                                        <i class="icon-arrow-right1"></i>
                                        <div class="endtime">{moment(result.end_date  ).format('ddd, MMM DD, YYYY')}</div>
                                        </div>
                                        
                                    </div>

                                    <div class="seats-wrpr">
                                        <label>Time</label>
                                        <div class="starttime-endtime">
                                        <div class="starttime">{moment(result.start_date).format('LT')}</div>
                                        <i class="icon-arrow-right1"></i>
                                        <div class="endtime">{moment(result.end_date).format('LT')}</div>
                                        </div>
                                    </div>

                                    </div> */}

                                    <hr style={{marginBottom:0}} />


                                    <div class="fees-wrpr">
                                        <div class="member-fee">
                                            <label>Year</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                {result?.year}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Registration Deadline</label>
                                            <div class="fee-content" style={{fontSize:'14px', maxWidth:'300px'}}>
                                                {result?.registration_date && moment(result?.registration_date).format('ddd, MMM DD, YYYY')}
                                            </div>
                                        </div>
                                        <div class="member-fee">
                                            <label>Publish Status</label>
                                            <div class="fee-content" style={{fontSize:'14px', color:result?.publish_status ==='PUBLISHED'?'green':'red'}}>
                                                {result?.publish}
                                            </div>
                                        </div>
                                    </div>

                                    <hr style={{marginBottom:0}} />

                                    <div class="fees-wrpr">
                                        <div class="member-fee">
                                            <label>Agreement</label>
                                            <div class="fee-content" style={{fontSize:'14px'}}>
                                                <a href={result?.agreement} target="_blank">Download <i className="icon-download8"></i></a>
                                            </div>
                                        </div>
                                        
                                    </div>

                                    <hr style={{marginBottom:0}} />

                                    <div className="list-action-wrpr showicons roundicons-text" style={{marginTop:'2%'}}>
                                        <div className="list-action-wrpr">

                                        <Link to={"/edit_exhibition/"+result?.id} data-toggle="tooltip" title="Edit"><i  class="edit icon-pencil3"></i><span>Update</span></Link>
                                        <button onClick={DeleteExibition} style={{background:"transparent"}} data-toggle="tooltip" title="Delete"><a><i class="delete icon-close1"></i><span>Delete</span></a></button>
                                        {/* {result.publish_status ==='PUBLISHED'?                                    
                                            <button onClick={PublishStatusSubmit} style={{background:"transparent"}} data-toggle="tooltip" title="Unpublish"><a><i class="delete icon-publish" style={{background:'#00eaad'}}></i><span>Unpublish</span></a></button>:
                                            <button onClick={(e)=>{PublishStatusSubmit(result.id)}} style={{background:"transparent"}} data-toggle="tooltip" title="Publish"><a><i class="delete icon-tick" style={{background:'#0069FF'}}></i><span>&nbsp;&nbsp;&nbsp;&nbsp;Publish&nbsp;&nbsp;&nbsp;&nbsp;</span></a></button>
                                        } */}
                                        </div>
                                    </div>
                                </div>  
                            </div>
                        </div>
                    </div>
                </div>
                }

                {
                    loader &&
                    <div className="loader" style={{textAlign:'center', marginTop:'20%'}}>
                        <div className="spinner-border text-primary" role="status">
                            <span className="sr-only">Loading...</span>
                        </div>
                    </div>
                }

                {
                    !result && !loader &&
                    <div className="loader" style={{textAlign:'center', marginTop:'20%'}}>
                        <h3>No Data Found</h3>
                    </div>
                }


            </div>
        </aside>
    </div>
    )
}

export default ExhibitionView;